import Header from "./header";
import Footer from './footer';

export default function Container({ children }: { children: JSX.Element }): JSX.Element {

    return <div className=" w-100 h-100 main-container"  >
        <Header></Header>
        {children}
        <Footer></Footer>
    </div>
}